import FacebookShareCard from './FacebookShareCard';

export type { FacebookShareCardProps } from './FacebookShareCard';

export default FacebookShareCard;
